<template>
    <div class="box">
        <div class="close" title="关闭" @click="close">
            <div class="iconfont icon-guanbi"></div>
        </div>
        <div class="content">
            <slot name="content"></slot>
        </div>
        <div class="btnMenu">
            <slot name="btnMenu"></slot>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        close() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="less" scoped>
.box {
    position: fixed;
    /* 响应式宽度：最大1250px，如果窗口小则占宽度的95% */
    width: 95vw;
    max-width: 1250px;
    
    /* 响应式高度：最大900px，如果窗口小则占高度的90%，防止溢出 */
    height: 90vh;
    max-height: 900px;

    /* 现代居中方案：不再需要 margin-top: -450px */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    /* 内容超出时允许在盒子内滚动，而不是被截断 */
    overflow-y: auto;

    background-image: url('../../../assets/img/maxwebImg/testIBgcmg.jpg');
    background-position: center; /* 改为居中显示背景 */
    background-size: cover;    /* 确保背景图覆盖整个区域 */
    border: 1px solid #88e3e1;
    z-index: 9999;
    padding: 10px;
    box-sizing: border-box;

    .close {
        position: absolute;
        right: 15px; /* 增加一点边距，更易点击 */
        top: 15px;
        color: #fff;
        cursor: pointer;
        z-index: 10001; /* 确保在最上层 */

        .iconfont {
            transition: all 0.5s;
            font-size: 24px; /* 稍微放大图标，方便操作 */
            color: aqua;
        }

        .iconfont:hover {
            color: #FF3300;
        }
    }

    .content {
        padding: 10px;
        box-sizing: border-box;
    }

    /* 隐藏滚动条美化（可选，如果需要显示滚动条可删掉此段） */
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(136, 227, 225, 0.3);
        border-radius: 3px;
    }

    .btnMenu {
        position: absolute;
        right: 10px;
        bottom: 10px;
    }
}

.box::-webkit-scrollbar {
    display: none;
}
</style>